import './Login.css';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import _ from 'lodash';

function Login(props) {
    const { org, onLogin, initError, setInitError } = props;
    const [ email, setEmail ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ waiting, setWaiting ] = useState(false);
    const [ error, setError ] = useState(false);

    async function onLoginClick() {
        setInitError(false);
        setWaiting(true);
        setError(false);
        try {
            const { data: accesstoken } = await axios(`/api/login/?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}&organizationId=${org.id}`);
            const { data: _org } = await axios(`/api/organizations/${org.id}?accesstoken=${accesstoken}`);
            const { data: _me } = await axios(`/api/organizations/${org.id}/me?accesstoken=${accesstoken}`);
            setWaiting(false);
            onLogin({ org: _org, me: _me, accesstoken });
        } catch {
            setWaiting(false);
            setError(true);
        }
    }

    return (
        <div>
            &nbsp;
            <Paper elevation={5} sx={{ position: 'fixed', top: 'calc(50% - 180px)', left: 'calc(50% - 200px)', padding: '12px', width: '400px' }}>
                <Typography variant='h5' sx={{ paddingTop: '16px' }}>
                {org.title}
                </Typography>
                <br/><br/>
                <FormControl variant='outlined' fullWidth>
                    <OutlinedInput
                        placeholder='Email'
                        id='email'
                        value={email}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => { setEmail(_.trim(event.target.value)) }}
                        disabled={waiting}
                    />
                </FormControl>
                <br/><br/>
                <FormControl variant='outlined' fullWidth>
                    <OutlinedInput
                        placeholder='Password'
                        id='password'
                        type='password'
                        value={password}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => { setPassword(event.target.value) }}
                        disabled={waiting}
                    />
                </FormControl>
                <br/><br/>
                <Button disabled={waiting} fullWidth onClick={onLoginClick} variant='contained'>
                    {!waiting ? <div style={{ height: '40px', lineHeight: '40px' }}>Login</div> : <CircularProgress />}
                </Button>
                <br/><br/>
                {error && (
                    <Alert severity='error'>Login failed. Check your email and password.</Alert>
                )}
                {initError && (
                    <Alert severity='error'>Error communicating with server. Please try again in a few seconds. If the problem persists, contact us.</Alert>
                )}
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                    <Typography variant='caption' sx={{ paddingRight: '3px', position: 'relative', top: '1px' }}>
                        Powered by
                    </Typography>
                    <Typography variant='caption' style={{ color: '#605DEC', fontSize: '14px', fontFamily: '\'DM Serif Display\', serif', fontWeight: '400' }}>
                        Monada
                    </Typography>
                </Box>
            </Paper>
        </div>
    );
}

export default Login;
